// Задано ли у человека имя — одно правило для кнопки меню и для подписи бота
// на встрече (решение владельца 29.09: «приведи к одному правилу»).
//
// Именем НЕ считается пустая строка, сама почта и её часть до @: у вошедших
// через Keycloak display_name заполняется логином (preferred_username), а это
// та же почта или её начало. Показывать такое вместо почты бессмысленно, а бот,
// подписанный логином, так же непонятен участникам встречи, как безымянный.

/** Имя из профиля, если оно настоящее, иначе null. */
export function realName(email, displayName) {
  const name = (displayName || '').trim();
  const mail = (email || '').trim().toLowerCase();
  const local = mail.split('@')[0];
  const low = name.toLowerCase();
  if (!name || low === mail || (local && low === local)) return null;
  return name;
}

/** Подпись кнопки меню: имя, если оно задано, иначе почта. */
export function accountLabel(email, displayName) {
  const name = realName(email, displayName);
  if (name) return { text: name, isName: true };
  return { text: (email || '').trim() || '—', isName: false };
}

// Инициалы: у имени — первые буквы двух слов («Владимир Фадеев» → «ВФ»),
// у почты — две первые буквы.
export function accountInitials(label) {
  if (label.isName) {
    // По символам, а не по UTF-16: эмодзи не рвётся пополам.
    const words = label.text.split(/\s+/).filter(Boolean).map((w) => Array.from(w));
    const letters = words.length > 1 ? words[0][0] + words[1][0] : words[0].slice(0, 2).join('');
    return letters.toUpperCase();
  }
  return (label.text === '—' ? '?' : label.text).slice(0, 2).toUpperCase();
}
